module.exports = __webpack_public_path__ + "static/media/Get in touch-pana.19d39c59.svg";